import React, { useState, useEffect ,useLayoutEffect} from 'react';
import useMedia from 'use-media';
import { useRtoaster } from '../../../hooks/useRtoaster';

import image_base from '../../../resources/image/HakoneGardenTerrace.jpg';
import { Link ,useHistory} from "react-router-dom";
import image_complete from '../../../resources/icons/complete.svg';
import image_button from '../../../resources/icons/ico_reserve.svg';
import { connect , useStore} from 'react-redux';
import common from '../../../resources/js/common/common';
import { apiKeyCheck } from '../../../const';
import { MembershipFooterContainer } from './../common/membershipFooterContainer';
import {Button} from '../../atoms/button';
import './../../../resources_membership_hotel/css/hotel/membership_cancel_wait_comp.css'

const CancelWaitCompleteContainer = (props) => {
    const {  } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    let data = {
        checkin:"2021-12-04",
        checkout:"2021-12-05",
        hakusu:1,
        facilityName:"エクシブ琵琶湖",
        roomNum:1,
        reserveNo:"12345678",
    }

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        // let state = store.getState().login;
        // let apiKey = null;
        // if(Object.keys(state).length !== 0){   
        //     apiKey = state.apiKey;
        // }
        // if(apiKey === null){
        //     store.dispatch({ type: "CLEAR_STATE"});
        //     history.push("/reserve/login");
        // }
        // if(apiKey){
        // common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        // }
    })
    const afterApiKeyCheck = (res) => {
        // if(!res.data){
        //     console.log("バックからの戻り値false");
        //     store.dispatch({ type: "CLEAR_STATE"});
        //     history.push("/reserve/login");
        // }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {

    }, []);

    //yyyy-mm-ddをyyyy年mm月dd日(曜日)形式に変換
    const dateForm = (res) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        var dateArr = res.split("-")
        let date = new Date(dateArr[0],dateArr[1] - 1,dateArr[2]);
        let convert = dateArr[0]+ "年" +dateArr[1]+ "月" + dateArr[2]+ "日" + "(" +  youbi[date.getDay()]+ ")";
        
        return convert;
    }

    return (
        <div style={isWideTablet ? styles.topCancel : styles.top}>
            <div className={isWideTablet ? "membership_cancel_wait_base2" : "membership_cancel_wait_base"}>
                <div style={styles.complete}></div>
                <p className="membership_cancel_wait_title">交換待ちの申込を完了しました。</p>
                <p className={isWideTablet ? "membership_cancel_wait_text2" : "membership_cancel_wait_text"}>
                    ご利用いただき誠にありがとうございます。<br />交換待ちも申し込み完了メールを{isWideTablet ? <br /> : null}お送りいたしましたので、
                    {isWideTablet ? null : <br />}内容をご確認ください。
                </p>
                <div className='membership_reserveinfo_area'>
                    <div className='membership_reserveinfo_content'>
                        <div className='membership_reserveinfo_title'>
                            <div>ご予約内容</div>
                        </div>
                        <div className='membership_reserveinfo_sub'>
                            <div>
                                <div className='membership_reserveinfo_data'>チェックイン</div>
                                <div className='membership_reserveinfo_data2 membership_reserve_black' >{dateForm(data.checkin)}</div>
                            </div>
                            <div>
                                <div className='membership_reserveinfo_data'>チェックアウト</div>
                                <div className='membership_reserveinfo_data2 membership_reserve_black'>{dateForm(data.checkout)}</div>
                            </div>
                            <div>
                                <div className='membership_reserveinfo_data'>泊数</div>
                                <div className='membership_reserveinfo_data2 membership_reserve_black'>{data.hakusu}泊</div>
                            </div>
                            <div className='membership_cancel_wait_pad'>
                                <div className={isWideTablet ? null : 'membership_reserveinfo_data'}>ホテル名</div>
                                <div className='membership_reserveinfo_data2 membership_reserve_black'>{data.facilityName}</div>
                            </div>
                            <div className='membership_cancel_wait_pad'>
                                <div className={isWideTablet ? null : 'membership_reserveinfo_data'}>室数</div>
                                <div className='membership_reserveinfo_data2 membership_reserve_black'>{data.roomNum}室</div>
                            </div>
                            <div className='membership_cancel_wait_pad'>
                                <div className={isWideTablet ? null : 'membership_reserveinfo_data'}>予約番号</div>
                                <div className='membership_reserveinfo_data2 membership_reserve_black'>{data.reserveNo}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='membership_btn_area'>
                <Button buttonText="ホテル予約TOPへ戻る" className="membership_top_btn"/>
                </div>
                <Link className='membership_reserve_link' to={"/reserve/hotel/search"} >予約一覧へ戻る</Link>
            </div>
            <div className={isWideTablet ? "membership_cancel_wait_footer2" : "membership_cancel_wait_footer"} >
                <MembershipFooterContainer />
            </div>
        </div >
    )
}

const styles = {
    topMobile: {
        width: "100%",
        paddingTop: "25px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (12.3rem + 75px))",
    },
    top: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (9.8rem + 100px))",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "white",
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "calc(100vh - (7.1rem + 100px))",
        height:"100%",
    },
    complete: {
        width: "50px",
        height: "50px",
        backgroundImage: `url(${image_complete})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        margin: "0px auto 10px",
    },

    box: {
        display: "inline-block",
        textAlign: "center",
        margin: "0px auto",
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "25px",
    },
    deletebr: {
        display: "none",
    },
    deletebr2: {
        display: "block",
    },
    btn: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "60%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btn2: {
        display: "flex",
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        width: "100%",
        height: "40px",
        margin: "30px auto",
        border: "none",
        justifyContent: "center",
    },
    btnImage: {
        width: "30px",
        height: "30px",
        backgroundImage: `url(${image_button})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        marginTop: "5px",
    },
    useBtn: {
        textAlign: "center",
        backgroundColor: "black",
        color: "white",
        display: "inline-block",
        border: "none"
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        marginLeft: "10%",
    },
    breadCrumbArrow: {
        marginRight: "16px",
        marginTop: "0px",
    },
    label: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: "0.9rem",
        letterSpacing: "0.2rem"
    },
    label2: {
        textAlign: "left",
        width: "80%",
        padding: "4px 0px",
        fontWeight: "bold",
        color: "#6f6f6f",
        fontSize: 12.6,
        letterSpacing: "0.2rem"
    },
    image: {
        width: 200,
        width: "40%",
        margin: "0 auto",
    },
    form: {
        width: "60%",
        margin: "0px auto 50px",
    },
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "45px auto 0px",
    },
}

export default CancelWaitCompleteContainer;